import { EMPTY_STRING } from "../../../constants";
import { NOTIFICATION_CHANGE_PLAN_APPROVED } from "./constants";

function formatTimestamp(timestamp) {
    const options = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
    };
    return new Intl.DateTimeFormat("en-US", options).format(
        new Date(timestamp)
    );
}

function formatChangeKey(changeKey) {
    // Converts PascalCase to user-friendly format
    // Also remove "StepSaved/SavedData" suffixes
    // Add ": " to the end if changeKey is presented. If not, keep it as empty string
    // e.g., "MarginGenerationStepSavedData" -> "Margin Generation: "
    const formattedChangeKey = changeKey
        .replace(/(StepSaved|Saved)Data/g, "")
        .replace(/([a-z])([A-Z])/g, "$1 $2");
    return formattedChangeKey ? `${formattedChangeKey}: ` : EMPTY_STRING;
}

function removeWordsFromPhrases(text, replacements) {
    /**
     * Removes specified words from phrases in a string based on a replacement object/map.
     *
     * @param {string} text - The input string to process
     * @param {Object|Map|Array} replacements - Object/Map where keys are original phrases
     *                                          and values are replacement phrases.
     *                                          Can also be an array of [key, value] pairs.
     * @returns {string} The modified string with replacements applied
     *
     * @example
     * const replacements = {"treatment plan": "plan"};
     * removeWordsFromPhrases("Review the treatment plan", replacements);
     * // Returns: 'Review the plan'
     */

    // Convert to string if not already
    let result = String(text);

    // Handle null, undefined, empty string, or empty replacements
    if (!text || !replacements) {
        return result;
    }

    // Apply each replacement
    for (const [original, replacement] of Object.entries(replacements)) {
        // Escape special regex characters and handle multiple whitespace
        const escapedOriginal = original.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const pattern = new RegExp(
            "\\b" + escapedOriginal.replace(/\s+/g, "\\s+") + "\\b",
            "gi"
        );
        result = result.replace(pattern, replacement);
    }

    return result;
}

export function getNotificationList(changeList) {
    changeList.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

    const replacements = { "treatment plan": "case", plan: "case" };
    return changeList.map((item, index) => (
        <li key={index} className="notification-item ml-4 pb-1">
            <span className="font-medium">
                {formatTimestamp(item.timestamp)}
            </span>{" "}
            - Changes made by{" "}
            <span className="font-medium">
                {item.updatedByUserInfo?.firstName}{" "}
                {item.updatedByUserInfo?.lastName}
            </span>{" "}
            ({item.updatedByUserInfo?.email}):
            <ul className="mb-0 ml-2 list-disc pt-1 pl-3">
                {item.changes &&
                    Object.entries(item.changes).map(
                        ([changeKey, changeValue], idx) => (
                            <li key={idx}>
                                <span className="font-medium">
                                    {formatChangeKey(changeKey)}
                                </span>
                                {removeWordsFromPhrases(
                                    changeValue,
                                    replacements
                                )}
                            </li>
                        )
                    )}
            </ul>
        </li>
    ));
}

export function isFirstTimePlanApproved(changeList) {
    // If NOTIFICATION_CHANGE_PLAN_APPROVED string is presented inside the change list, return false
    return !changeList?.some((item) =>
        item.changes?.SavedData?.includes(NOTIFICATION_CHANGE_PLAN_APPROVED)
    );
}
